import React from 'react';
import './styles/Cleaning.css';
import './styles/App.css';
import 'material-symbols/outlined.css';
import {CellWithIcon} from "./components/CellWithIcon";
import {Analytics} from "@vercel/analytics/react";

function App() {
  return (
    <div className="App">
      <div className="Hello">
        <h2>
          Hey! I'm <span className="nowrap">Maks Naumenko</span> — Python <span
          className="nowrap">Backend Developer</span>.
        </h2>
      </div>
      <CellWithIcon
        text="Linkedin"
        link="https://www.linkedin.com/in/maks-naumenko"
        background="/linkedin.webp"
        cls="Linkedin"
      />
      <CellWithIcon
        text="My experiments"
        cls="Experiments"
        background="/brush.webp"
        draft={true}
      />
      <CellWithIcon
        text="About me"
        cls="About-me"
        background="/about-me.webp"
        draft={true}
      />
      <CellWithIcon
        text="Github"
        link="https://github.com/djimontyp"
        background="/github.webp"
        cls="Github"
      />
      <div className="Footer Cell">
        <h6>© All rights reserved. And all that stuff. 🤷</h6>
      </div>
      <Analytics />
    </div>
  );
}

export default App;
